import React from 'react';

import { Image, ImageProps } from '@mantine/core';
import { IsoCountryCode } from 'shared/interfaces/Country';

interface CountryFlagImageProps extends ImageProps {
  countryCode: IsoCountryCode;
}

export function CountryFlagImage({ countryCode, ...imageProps }: CountryFlagImageProps) {
  return (
    <Image
      src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${countryCode.toUpperCase()}.svg`}
      width={16}
      height={12}
      fit="contain"
      {...imageProps}
    />
  );
}
